import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=f10e68b4&scoped=true"
import script from "./PostEdit.vue?vue&type=script&lang=ts"
export * from "./PostEdit.vue?vue&type=script&lang=ts"
import style0 from "./PostEdit.vue?vue&type=style&index=0&id=f10e68b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e68b4",
  null
  
)

/* custom blocks */
import block0 from "./PostEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports